import { Comparator } from './types';

export const EQUAL: Comparator = '=';
export const GREATER_THAN: Comparator = '>';
export const GREATER_THAN_OR_EQUAL: Comparator = '>=';
export const LESS_THAN: Comparator = '<';
export const LESS_THAN_OR_EQUAL: Comparator = '<=';
export const NOT_EQUAL: Comparator = '!=';
export const INT_COMPARATORS: Comparator[] = [
  EQUAL,
  GREATER_THAN,
  GREATER_THAN_OR_EQUAL,
  LESS_THAN,
  LESS_THAN_OR_EQUAL,
  NOT_EQUAL,
];
export const STRING_COMPARATORS: Comparator[] = [EQUAL, NOT_EQUAL];

// Comparator conversion maps
export const COMPARATOR_API_MAP = {
  '>': 'gt',
  '>=': 'gte',
  '<': 'lt',
  '<=': 'lte',
  '!=': 'ne',
};

// Comparator conversion maps
export const ADVANCED_OPTIONS_PARAMS = new Set([
  'derived_only',
  'non_derived_only',
  'primary_only',
  'secondary_only',
]);
